
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/software-development-services-for-tech-businesses",
      function () {
        return require("private-next-pages/software-development-services-for-tech-businesses.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/software-development-services-for-tech-businesses"])
      });
    }
  